export default __webpack_public_path__ + "static/media/users.fab865d8.svg";